import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

const ATLAS_URL = 'https://www.mongodb.com/cloud/atlas/register';

const STEPS = [
  {
    n: 1,
    hi: 'MongoDB Atlas पर FREE account बनाएँ',
    en: 'Create a FREE MongoDB Atlas account',
    hiDesc: 'नीचे दिए बटन से Atlas खोलें और Google/Email से sign up करें। कोई card ज़रूरी नहीं।',
    enDesc: 'Open Atlas below and sign up with Google/Email. No credit card needed.',
  },
  {
    n: 2,
    hi: 'FREE Cluster (M0) बनाएँ',
    en: 'Create a FREE Cluster (M0)',
    hiDesc: '"Create" → Deployment में M0 (FREE) चुनें → Region: Mumbai (ap-south-1) → Create।',
    enDesc: 'Click "Create" → pick M0 (FREE) → Region: Mumbai (ap-south-1) → Create.',
  },
  {
    n: 3,
    hi: 'Database User बनाएँ',
    en: 'Create a Database User',
    hiDesc: 'Security → Database Access → Add New User → username व मज़बूत password डालें, कहीं note कर लें।',
    enDesc: 'Security → Database Access → Add New User → set a username & strong password, note it down.',
  },
  {
    n: 4,
    hi: 'Network Access खोलें',
    en: 'Allow Network Access',
    hiDesc: 'Security → Network Access → Add IP Address → "Allow Access from Anywhere" (0.0.0.0/0) → Confirm।',
    enDesc: 'Security → Network Access → Add IP Address → "Allow Access from Anywhere" (0.0.0.0/0) → Confirm.',
  },
  {
    n: 5,
    hi: 'Connection String कॉपी करें',
    en: 'Copy the Connection String',
    hiDesc: 'Cluster → Connect → Drivers → connection string कॉपी करें। उसमें <password> की जगह अपना असली password डालें।',
    enDesc: 'Cluster → Connect → Drivers → copy the string. Replace <password> with your real password.',
  },
  {
    n: 6,
    hi: 'यहाँ पेस्ट करके Connect करें',
    en: 'Paste it here & Connect',
    hiDesc: 'ऊपर के फ़ॉर्म में connection string पेस्ट करें → Test → Activate। बस! आपका डेटा अब आपके अपने DB में।',
    enDesc: 'Paste the string in the form above → Test → Activate. Done! Your data now lives in your own DB.',
  },
];

export default function MongoAtlasGuide({ language = 'hi', onClose }) {
  const hi = language === 'hi';
  return (
    <div
      className="fixed inset-0 z-[100] bg-black/60 flex items-center justify-center p-4"
      data-testid="mongo-atlas-guide-modal"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl max-w-2xl w-full max-h-[88vh] overflow-y-auto shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sticky top-0 bg-gradient-to-r from-emerald-600 to-green-600 text-white px-6 py-5 rounded-t-2xl flex items-start justify-between">
          <div>
            <h3 className="text-xl font-bold">
              {hi ? '🗄️ अपना FREE Database कैसे बनाएँ?' : '🗄️ How to create your FREE Database'}
            </h3>
            <p className="text-emerald-50 text-sm mt-1">
              {hi
                ? 'MongoDB Atlas M0 — 512MB, हमेशा FREE। सिर्फ़ 6 आसान steps, ~5 मिनट।'
                : 'MongoDB Atlas M0 — 512MB, FREE forever. Just 6 easy steps, ~5 min.'}
            </p>
          </div>
          <button
            onClick={onClose}
            className="text-white/80 hover:text-white text-2xl leading-none"
            data-testid="close-atlas-guide"
          >
            ×
          </button>
        </div>

        <div className="p-6 space-y-4">
          <div className="flex flex-col sm:flex-row items-center gap-4 bg-emerald-50 border border-emerald-200 rounded-xl p-4">
            <a
              href={ATLAS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="px-5 py-2.5 bg-emerald-600 text-white rounded-lg font-medium hover:bg-emerald-700 whitespace-nowrap"
              data-testid="open-atlas-link"
            >
              {hi ? '🔗 MongoDB Atlas खोलें' : '🔗 Open MongoDB Atlas'}
            </a>
            <div className="flex items-center gap-3">
              <div className="bg-white p-1.5 rounded-lg border">
                <QRCodeSVG value={ATLAS_URL} size={70} />
              </div>
              <p className="text-xs text-gray-500">
                {hi ? '📱 मोबाइल से खोलने के लिए QR स्कैन करें' : '📱 Scan QR to open on mobile'}
              </p>
            </div>
          </div>

          {STEPS.map((s) => (
            <div key={s.n} className="flex gap-3" data-testid={`atlas-step-${s.n}`}>
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-emerald-600 text-white flex items-center justify-center font-bold text-sm">
                {s.n}
              </div>
              <div>
                <p className="font-semibold text-gray-800">{hi ? s.hi : s.en}</p>
                <p className="text-sm text-gray-600 mt-0.5">{hi ? s.hiDesc : s.enDesc}</p>
              </div>
            </div>
          ))}

          <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 text-sm text-amber-800">
            {hi
              ? '⚠️ ध्यान: connection string में password वाली जगह <password> लिखा होता है — उसे अपने असली password से बदलें, वरना connect नहीं होगा।'
              : '⚠️ Note: the connection string contains <password> — replace it with your real password, otherwise it will not connect.'}
          </div>
        </div>
      </div>
    </div>
  );
}
